<template>
<div class="sidebar dash-sidebar">
	<div class="collapse-button" @click="toggleMenu()">
		<img src="@/assets/images/left-arrow.png" alt="left-arrow">
	</div>
	<div class="dash-menu"></div>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.dash-sidebar {
	padding: 0 !important;
	background: #1e262d !important;
	top: 0;
	bottom: 0;
	border-radius: 0;
	position: absolute;
	z-index: 1;
	left: 56px;
	border: none !important;
	border-radius: 0 !important;
	width: 56px !important;
	
	.dash-menu {
		background-image: url('../../../assets/images/dash-menu.png');
		height: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: -7px 60px;
		cursor: pointer;
	}
	.collapse-button {
		float: right;
		width: 20px;
		height: 20px;
		border-right: 2px solid #fff;
		padding: 2px 4px;
		margin-top: 18px;
		margin-right: 15px;
		cursor: pointer;
		transition: transform 0.5s linear;

		img {
			width: 100%;
		}
	}
}
</style>
